import React from 'react';
import './ApprovalModal.css';

const ApprovalModal = ({ 
    show, 
    task, 
    action, 
    remarks, 
    onRemarksChange, 
    onSubmit, 
    onClose 
}) => {
    if (!show || !task) return null;

    const handleSubmit = () => {
        if (action === 'reject' && !remarks.trim()) {
            alert('Please provide a reason for rejection');
            return;
        }
        onSubmit();
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>{action === 'approve' ? 'Approve Request' : 'Reject Request'}</h2>
                <div className="modal-body">
                    <div className="task-info">
                        <p><strong>Title:</strong> {task.title}</p>
                        <p><strong>Description:</strong> {task.description}</p>
                        <p><strong>Requested By:</strong> {task.assignedByName}</p>
                        <p><strong>Priority:</strong> {task.priority}</p>
                    </div>
                    <div className="form-group">
                        <label>
                            {action === 'approve' ? 'Remarks (Optional)' : 'Reason for Rejection *'}
                        </label>
                        <textarea 
                            value={remarks} 
                            onChange={(e) => onRemarksChange(e.target.value)}
                            placeholder={action === 'approve' ? 'Add any remarks...' : 'Please provide a reason for rejection'}
                            rows="4"
                            required={action === 'reject'}
                        />
                    </div>
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="btn-secondary">
                        Cancel
                    </button>
                    <button 
                        onClick={handleSubmit} 
                        className={action === 'approve' ? 'btn-approve' : 'btn-reject'}
                    >
                        {action === 'approve' ? 'Approve' : 'Reject'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApprovalModal;
